import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import {
	Box,
	Checkbox,
	DialogContent,
	FormControl,
	FormControlLabel,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { getGpsrPlans, getRegParser } from 'redux/reducers/gpsr/selectors';
import {
	getGpsrPlansRequest,
	registerGpsrRequest,
	regParseGpsrRequest,
} from 'redux/reducers/gpsr/reducer';
import { TGpsrRegisterDialogProps } from './types';
import { validationSchema } from './validationSchema';
import { DatePickerComponent } from '../../../ui/DatePickerComponent';

export const GpsrRegisterDialog: FC<TGpsrRegisterDialogProps> = ({
	open,
	setClose,
	title = 'GPSR Register',
}) => {
	const dispatch = useDispatch();
	const [newComment, setNewComment] = useState<string>('');

	const [sellingTypeOfProducts, setSellingTypeOfProducts] = useState<string>('');
	const [isSellingToEU, setIsSellingToEU] = useState<boolean>(false);
	const [sellingPlace, setSellingPlace] = useState<string>('');
	const [firstName, setFirstName] = useState<string>('');
	const [lastName, setLastName] = useState<string>('');
	const [phoneNumber, setPhoneNumber] = useState<string>('');
	const [email, setEmail] = useState<string>('');
	const [company, setCompany] = useState<string>('');
	const [address1, setAddress1] = useState<string>('');
	const [address2, setAddress2] = useState<string>('');
	const [cityTown, setCityTown] = useState<string>('');
	const [stateRegionProvince, setStateRegionProvince] = useState<string>('');
	const [zipCode, setZipCode] = useState<string>('');
	const [country, setCountry] = useState<string>('');
	const [businessRegistrationNumber, setBusinessRegistrationNumber] = useState<string>('');
	const [storeAddress, setStoreAddress] = useState<string>('');
	// const [subscriptionPlan, setSubscriptionPlan] = useState<string>('');
	// const [additionalProductsTypes, setAdditionalProductsTypes] = useState<string>('0');
	const [numberOfProductTypes, setNumberOfProductTypes] = useState<string>('0');
	const [subscriptionPlan, setSubscriptionPlan] = useState<string>('');
	const [periodStart, setPeriodStart] = useState<string>('');
	const [periodEnd, setPeriodEnd] = useState<string>('');
	// const [dateStart, setDateStart] = useState<DateTime | null>(null);
	// const [dateEnd, setDateEnd] = useState<DateTime | null>(null);

	const gpsrRegParser = useSelector(getRegParser);
	const gpsrPlans = useSelector(getGpsrPlans);

	console.log('numberOfProductTypes', numberOfProductTypes);

	const reset = () => {
		setNewComment('');
		setSellingTypeOfProducts('');
		setIsSellingToEU(false);
		setSellingPlace('');
		setFirstName('');
		setLastName('');
		setPhoneNumber('');
		setEmail('');
		setCompany('');
		setAddress1('');
		setAddress2('');
		setCityTown('');
		setStateRegionProvince('');
		setZipCode('');
		setCountry('');
		setBusinessRegistrationNumber('');
		setStoreAddress('');
		setNumberOfProductTypes('');
		setSubscriptionPlan('');
		setPeriodStart('');
		setPeriodEnd('');
		// setDateStart(null);
		// setDateEnd(null);
	};

	const formikGpsr = useFormik({
		initialValues: {
			sellingTypeOfProducts,
			isSellingToEU,
			sellingPlace,
			firstName,
			lastName,
			phoneNumber,
			email,
			company,
			address1,
			address2,
			cityTown,
			stateRegionProvince,
			zipCode,
			country,
			businessRegistrationNumber,
			storeAddress,
			numberOfProductTypes,
			subscriptionPlan,
			periodStart,
			periodEnd,
			// dateStart,
			// dateEnd,
		},
		enableReinitialize: true,
		validationSchema,
		// onSubmit: (values) => {
		// 	console.log('onSubmit', values);
		// },

		onSubmit: (values) => {
			dispatch(
				registerGpsrRequest({
					sellingTypeOfProducts: values.sellingTypeOfProducts,
					isSellingToEU: values.isSellingToEU,
					sellingPlace: values.sellingPlace,
					firstName: values.firstName,
					lastName: values.lastName,
					phoneNumber: values.phoneNumber,
					email: values.email,
					company: values.company,
					address1: values.address1,
					address2: values.address2,
					cityTown: values.cityTown,
					stateRegionProvince: values.stateRegionProvince,
					zipCode: values.zipCode,
					country: values.country,
					businessRegistrationNumber: values.businessRegistrationNumber,
					storeAddress: values.storeAddress,
					numberOfAdditionalProductTypes: Number(values.numberOfProductTypes),
					subscriptionPlanId:
						gpsrPlans?.find((plan) => plan.userVisibleName === values.subscriptionPlan)?.id ?? 0,
					periodStart: values.periodStart,
					periodEnd: values.periodEnd,
				}),
			);
			formikGpsr.resetForm();
			reset();
			setClose();
		},
	});

	useEffect(() => {
		dispatch(getGpsrPlansRequest());
	}, [dispatch]);

	useEffect(() => {
		console.log('useEffect', gpsrRegParser);
		if (!open) return;
		if (!setNewComment) return;
		setSellingTypeOfProducts(gpsrRegParser?.sellingTypeOfProducts ?? '');
		setIsSellingToEU(gpsrRegParser?.isSellingToEU ?? false);
		setSellingPlace(gpsrRegParser?.sellingPlace ?? '');
		setFirstName(gpsrRegParser?.firstName ?? '');
		setLastName(gpsrRegParser?.lastName ?? '');
		setPhoneNumber(gpsrRegParser?.phoneNumber ?? '');
		setEmail(gpsrRegParser?.email ?? '');
		setCompany(gpsrRegParser?.company ?? '');
		setAddress1(gpsrRegParser?.address1 ?? '');
		setAddress2(gpsrRegParser?.address2 ?? '');
		setCityTown(gpsrRegParser?.cityTown ?? '');
		setStateRegionProvince(gpsrRegParser?.stateRegionProvince ?? '');
		setZipCode(gpsrRegParser?.zipCode ?? '');
		setCountry(gpsrRegParser?.country ?? '');
		setBusinessRegistrationNumber(gpsrRegParser?.businessRegistrationNumber ?? '');
		setStoreAddress(gpsrRegParser?.storeAddress ?? '');
		setNumberOfProductTypes(String(gpsrRegParser?.numberOfAdditionalProductTypes ?? '0'));
		setSubscriptionPlan(
			gpsrPlans?.find((plan) => plan.id === (gpsrRegParser?.subscriptionPlanId ?? 0))
				?.userVisibleName ?? '',
		);
		setPeriodStart(gpsrRegParser?.periodStart ?? '');
		setPeriodEnd(gpsrRegParser?.periodEnd ?? '');
		// setDateStart(gpsrRegParser?.periodStart ? DateTime.fromISO(gpsrRegParser?.periodStart) : null);
		// setDateEnd(gpsrRegParser?.periodEnd ? DateTime.fromISO(gpsrRegParser?.periodEnd) : null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [gpsrRegParser]);

	const handleParse = () => {
		dispatch(
			regParseGpsrRequest({
				urlEncodedRawRegistrationData: newComment,
			}),
		);
	};

	const handleParseText = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNewComment(e.target.value);
		dispatch(
			regParseGpsrRequest({
				urlEncodedRawRegistrationData: e.target.value,
			}),
		);
	};

	const handleDateStart = (date: DateTime | null) => {
		formikGpsr.setFieldValue('periodStart', date?.toISODate() ?? '').catch((error) => {
			console.error('Error setting period Start:', error);
		});
	};

	const handleDateEnd = (date: DateTime | null) => {
		formikGpsr.setFieldValue('periodEnd', date?.toISODate() ?? '').catch((error) => {
			console.error('Error setting period End:', error);
		});
	};

	return (
		<Dialog
			open={open}
			sx={{
				'& .MuiDialog-paper': {
					width: '1400px',
					maxWidth: '1400px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary" fontWeight="bold">
				{title}
			</DialogTitle>
			<form onSubmit={formikGpsr.handleSubmit}>
				<DialogContent
					sx={{
						p: '0 12px 0px 12px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
						}}
					>
						<Box
							sx={{
								width: '100%',
								border: '1px solid #016193',
								p: '8px',
								borderRadius: '12px',
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
								justifyContent: 'space-between',
							}}
						>
							<Typography color="primary" sx={{ fontSize: '0.9rem' }}>
								Paste Typeform email notification:
							</Typography>
							<TextField
								sx={{
									// mt: '10px',
									'& .MuiInputBase-root': {
										padding: '6px 8px',
										lineHeight: '1.2',
										// fontSize: '0.9rem',
										// height: '100%',
									},
								}}
								autoFocus
								// label="Add New Comment"
								value={newComment}
								onChange={handleParseText}
								type="text"
								fullWidth
								multiline
								rows={26}
							/>
						</Box>

						<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
							<FormControlLabel
								sx={{
									mt: '10px',
								}}
								control={
									<Checkbox
										id="isSellingToEU"
										name="isSellingToEU"
										checked={formikGpsr.values.isSellingToEU}
										onChange={formikGpsr.handleChange}
									/>
								}
								label="Is selling to EU"
							/>

							<TextField
								id="sellingTypeOfProducts"
								name="sellingTypeOfProducts"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Selling type of products"
								value={formikGpsr.values.sellingTypeOfProducts}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.sellingTypeOfProducts &&
									Boolean(formikGpsr.errors.sellingTypeOfProducts)
								}
								helperText={
									formikGpsr.touched.sellingTypeOfProducts &&
									formikGpsr.errors.sellingTypeOfProducts
								}
							/>
							<TextField
								id="sellingPlace"
								name="sellingPlace"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Selling place"
								value={formikGpsr.values.sellingPlace}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.sellingPlace && Boolean(formikGpsr.errors.sellingPlace)}
								helperText={formikGpsr.touched.sellingPlace && formikGpsr.errors.sellingPlace}
							/>

							<TextField
								id="firstName"
								name="firstName"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="First name"
								value={formikGpsr.values.firstName}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.firstName && Boolean(formikGpsr.errors.firstName)}
								helperText={formikGpsr.touched.firstName && formikGpsr.errors.firstName}
							/>

							<TextField
								id="lastName"
								name="lastName"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Last name"
								value={formikGpsr.values.lastName}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.lastName && Boolean(formikGpsr.errors.lastName)}
								helperText={formikGpsr.touched.lastName && formikGpsr.errors.lastName}
							/>

							<TextField
								id="phoneNumber"
								name="phoneNumber"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Phone number"
								value={formikGpsr.values.phoneNumber}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.phoneNumber && Boolean(formikGpsr.errors.phoneNumber)}
								helperText={formikGpsr.touched.phoneNumber && formikGpsr.errors.phoneNumber}
							/>

							<TextField
								id="email"
								name="email"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Email"
								value={formikGpsr.values.email}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.email && Boolean(formikGpsr.errors.email)}
								helperText={formikGpsr.touched.email && formikGpsr.errors.email}
							/>
							<TextField
								id="company"
								name="company"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Company"
								value={formikGpsr.values.company}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.company && Boolean(formikGpsr.errors.company)}
								helperText={formikGpsr.touched.company && formikGpsr.errors.company}
							/>

							<TextField
								id="address1"
								name="address1"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Address 1"
								value={formikGpsr.values.address1}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.address1 && Boolean(formikGpsr.errors.address1)}
								helperText={formikGpsr.touched.address1 && formikGpsr.errors.address1}
							/>
							<TextField
								id="address2"
								name="address2"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Address 2"
								value={formikGpsr.values.address2}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.address2 && Boolean(formikGpsr.errors.address2)}
								helperText={formikGpsr.touched.address2 && formikGpsr.errors.address2}
							/>
						</Box>

						<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
							<TextField
								id="cityTown"
								name="cityTown"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="City/Town"
								value={formikGpsr.values.cityTown}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.cityTown && Boolean(formikGpsr.errors.cityTown)}
								helperText={formikGpsr.touched.cityTown && formikGpsr.errors.cityTown}
							/>

							<TextField
								id="stateRegionProvince"
								name="stateRegionProvince"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="State/Region/Province"
								value={formikGpsr.values.stateRegionProvince}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.stateRegionProvince &&
									Boolean(formikGpsr.errors.stateRegionProvince)
								}
								helperText={
									formikGpsr.touched.stateRegionProvince && formikGpsr.errors.stateRegionProvince
								}
							/>

							<TextField
								id="zipCode"
								name="zipCode"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Zip Code"
								value={formikGpsr.values.zipCode}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.zipCode && Boolean(formikGpsr.errors.zipCode)}
								helperText={formikGpsr.touched.zipCode && formikGpsr.errors.zipCode}
							/>

							<TextField
								id="country"
								name="country"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Country"
								value={formikGpsr.values.country}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.country && Boolean(formikGpsr.errors.country)}
								helperText={formikGpsr.touched.country && formikGpsr.errors.country}
							/>

							<TextField
								id="businessRegistrationNumber"
								name="businessRegistrationNumber"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Business Registration Number"
								value={formikGpsr.values.businessRegistrationNumber}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.businessRegistrationNumber &&
									Boolean(formikGpsr.errors.businessRegistrationNumber)
								}
								helperText={
									formikGpsr.touched.businessRegistrationNumber &&
									formikGpsr.errors.businessRegistrationNumber
								}
							/>

							<TextField
								id="storeAddress"
								name="storeAddress"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Store Address"
								value={formikGpsr.values.storeAddress}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={formikGpsr.touched.storeAddress && Boolean(formikGpsr.errors.storeAddress)}
								helperText={formikGpsr.touched.storeAddress && formikGpsr.errors.storeAddress}
							/>
							<TextField
								id="numberOfProductTypes"
								name="numberOfProductTypes"
								size="small"
								sx={{
									mt: '12px',
								}}
								label="Additional Product Types"
								value={formikGpsr.values.numberOfProductTypes}
								onChange={formikGpsr.handleChange}
								onBlur={formikGpsr.handleBlur}
								type="text"
								fullWidth
								error={
									formikGpsr.touched.numberOfProductTypes &&
									Boolean(formikGpsr.errors.numberOfProductTypes)
								}
								helperText={
									formikGpsr.touched.numberOfProductTypes && formikGpsr.errors.numberOfProductTypes
								}
							/>

							<FormControl fullWidth sx={{ mt: '6px' }}>
								<InputLabel id="subscriptionPlanLabel">Subscription Plan</InputLabel>
								<Select
									id="subscriptionPlan"
									labelId="subscriptionPlanLabel"
									label="Subscription Plan"
									name="subscriptionPlan"
									value={formikGpsr.values.subscriptionPlan}
									onChange={formikGpsr.handleChange}
									fullWidth
									size="small"
									sx={{ mt: '6px' }}
								>
									{gpsrPlans?.map?.((plan) => (
										<MenuItem key={plan.id} value={plan.userVisibleName}>
											{plan.userVisibleName}
										</MenuItem>
									))}
								</Select>
								<FormHelperText>
									{formikGpsr.touched.subscriptionPlan && formikGpsr.errors.subscriptionPlan}
								</FormHelperText>
							</FormControl>

							<DatePickerComponent
								id="dateStart"
								value={DateTime.fromISO(formikGpsr.values.periodStart ?? '')}
								onChange={handleDateStart}
								label="Period Start"
							/>

							<DatePickerComponent
								id="dateEnd"
								value={DateTime.fromISO(formikGpsr.values.periodEnd ?? '')}
								onChange={handleDateEnd}
								// disabled = {!gpsrRegParser}
								label="Period End"
							/>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							formikGpsr.resetForm();
							reset();
							setClose();
						}}
					>
						Cancel
					</Button>
					<Button type="submit" autoFocus>
						Send
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};
